// Copyright 2018 Sorama B.V.

export enum FormatFeature {
    Transparency,
    Vector,
    Video,
}

export interface Format {
    readonly name: string;

    supports(flag: FormatFeature);
}

export abstract class FormatBase implements Format {
    private readonly supportedFeatures: FormatFeature[];
    private readonly _name: string;
    public get name(): string {
        return this._name;
    }

    protected constructor(name: string, supportedFeatures: FormatFeature[]) {
        this._name = name;
        this.supportedFeatures = supportedFeatures;
    }

    public supports(feature: FormatFeature) {
        return this.supportedFeatures.indexOf(feature) !== -1;
    }
}

export class VideoFormat extends FormatBase {
    protected constructor(name: string, additionalFeatures?: FormatFeature[]) {
        super(name, additionalFeatures ? additionalFeatures.concat([FormatFeature.Video]) : [FormatFeature.Video]);
    }

    public static readonly mp4: VideoFormat = new VideoFormat("MP4");
    public static readonly webm: VideoFormat = new VideoFormat("WebM");

    public static parse(name: string): VideoFormat {
        if (!name) return undefined;

        return VideoFormat.all.find((x) => x.name.toLowerCase() === name.toLowerCase());
    }

    public static get all(): VideoFormat[] {
        return [VideoFormat.mp4, VideoFormat.webm];
    }
}

export class ImageFormat extends FormatBase {
    protected constructor(name: string, features?: FormatFeature[]) {
        super(name, features ? features : []);
    }

    public static readonly png: ImageFormat = new ImageFormat("PNG", [FormatFeature.Transparency]);
    public static readonly jpeg: ImageFormat = new ImageFormat("JPEG");

    public static parse(name: string): ImageFormat {
        if (!name) return undefined;

        return ImageFormat.all.find((x) => x.name.toLowerCase() === name.toLowerCase());
    }

    public static get all(): ImageFormat[] {
        return [ImageFormat.png, ImageFormat.jpeg];
    }
}
